<form [formGroup]="form">
    <fieldset>

        <h2 i18n="@@step3Header">Je contactgegevens</h2>

        <div class="text-input">
            <input type="text"
                class="text-input-input"
                formControlName="givenName">
            <label class="text-label"
                i18n="@@givenName">
                Voornaam
            </label>
            <ig-validator [form]="form"
                ctrl="givenName"
                [submitted]="submitted">
            </ig-validator>
            <ig-feedback-group *ngIf="submitted">
                <ig-feedback *ngIf="errors('givenName').required"
                    i18n="@@givenName.errors.required">
                    Voornaam is verplicht
                </ig-feedback>
            </ig-feedback-group>
        </div>

        <div class="text-input">
            <input type="text"
                class="text-input-input"
                formControlName="surName">
            <label class="text-label"
                i18n="@@surName">
                Achternaam
            </label>
            <ig-validator [form]="form"
                ctrl="surName"
                [submitted]="submitted">
            </ig-validator>
            <ig-feedback-group *ngIf="submitted">
                <ig-feedback *ngIf="errors('surName').required"
                    i18n="@@surName.errors.required">
                    Achternaam is verplicht
                </ig-feedback>
            </ig-feedback-group>
        </div>

        <h3 i18n="@@step3SectionAddress">Adres</h3>

        <div class="flex">
            <div>
                <div class="text-input">
                    <input type="text"
                        class="text-input-input"
                        formControlName="postcode">
                    <label class="text-label"
                        i18n="@@postcode">Postcode</label>
                    <ig-validator [form]="form"
                        ctrl="postcode"
                        [submitted]="submitted">
                    </ig-validator>
                    <ig-feedback-group *ngIf="submitted">
                        <ig-feedback *ngIf="errors('postcode').required"
                            i18n="@@postcode.errors.required">Postcode is verplicht</ig-feedback>
                        <ig-feedback *ngIf="errors('postcode').minlength"
                            i18n="@@postcode.errors.minlength">Postcode moet 4 cijfers bevatten</ig-feedback>
                        <ig-feedback *ngIf="errors('postcode').pattern"
                            i18n="@@postcode.errors.pattern">Geen geldige postcode</ig-feedback>
                    </ig-feedback-group>
                </div>
            </div>
            <span class="space"></span>
            <div>
                <div class="text-input">
                    <input type="text"
                        class="text-input-input"
                        formControlName="city">
                    <label class="text-label"
                        i18n="@@city">
                        Plaats
                    </label>
                    <ig-validator [form]="form"
                        ctrl="city"
                        [submitted]="submitted">
                    </ig-validator>
                    <ig-feedback-group *ngIf="submitted">
                        <ig-feedback *ngIf="errors('city').required"
                            i18n="@@city.errors.required">
                            Plaats is verplicht
                        </ig-feedback>
                    </ig-feedback-group>
                </div>
            </div>
        </div>

        <div class="flex">
            <div>
                <div class="text-input">
                    <input type="text"
                        class="text-input-input"
                        formControlName="street">
                    <label class="text-label"
                        i18n="@@street">
                        Straatnaam
                    </label>
                    <ig-validator [form]="form"
                        ctrl="street"
                        [submitted]="submitted">
                    </ig-validator>
                    <ig-feedback-group *ngIf="submitted">
                        <ig-feedback *ngIf="errors('street').required"
                            i18n="@@street.errors.required">
                            Straatnaam is verplicht
                        </ig-feedback>
                    </ig-feedback-group>
                </div>
            </div>
            <span class="space"></span>
            <div class="flex-combo">
                <div class="text-input">
                    <input type="text"
                        class="text-input-input"
                        formControlName="number">
                    <label class="text-label"
                        i18n="@@houseNumber">
                        Huisnummer
                    </label>
                    <ig-validator [form]="form"
                        ctrl="number"
                        [submitted]="submitted">
                    </ig-validator>
                    <ig-feedback-group *ngIf="submitted">
                        <ig-feedback *ngIf="errors('number').required"
                            i18n="@@houseNumber.errors.required">
                            Huisnummer is verplicht
                        </ig-feedback>
                    </ig-feedback-group>
                </div>
                <span class="space"></span>
                <div class="text-input">
                    <input type="text"
                        class="text-input-input"
                        formControlName="addition">
                    <label class="text-label"
                        i18n="@@houseNumberExtension">
                        Toevoeging
                    </label>
                    <ig-validator [form]="form"
                        ctrl="addition"
                        [submitted]="submitted">
                    </ig-validator>
                </div>
            </div>
        </div>
    </fieldset>

    <fieldset>
        <h3 i18n="@@step3SectionInfo">Hoe kunnen we je bereiken?</h3>

        <div class="text-input">
            <input type="tel"
                class="text-input-input"
                formControlName="firstPhoneNumber">
            <label class="text-label"
                i18n="@@phone">
                Telefoonnummer
            </label>
            <ig-validator [form]="form"
                ctrl="firstPhoneNumber"
                [submitted]="submitted">
            </ig-validator>
            <ig-feedback-group *ngIf="submitted">
                <ig-feedback *ngIf="errors('firstPhoneNumber').required"
                    i18n="@@phone.errors.required">Telefoonnummer is verplicht</ig-feedback>
                <ig-feedback *ngIf="errors('firstPhoneNumber').minlength"
                    i18n="@@phone.errors.minlength">Telefoonnummer moet minimaal 9 karakters
                    bevatten</ig-feedback>
                <ig-feedback *ngIf="errors('firstPhoneNumber').maxlength"
                    i18n="@@phone.errors.maxlength">Telefoonnummer mag maximaal 10 karakters
                    bevatten</ig-feedback>
                <ig-feedback *ngIf="errors('firstPhoneNumber').pattern"
                    i18n="@@phone.errors.pattern">Ongeldig telefoonnummer</ig-feedback>
            </ig-feedback-group>
        </div>
        <div class="text-input">
            <input type="email"
                class="text-input-input"
                formControlName="emailAddress">
            <label class="text-label"
                i18n="@@email">
                E-mailadres
            </label>
            <ig-validator [form]="form"
                ctrl="emailAddress"
                [submitted]="submitted">
            </ig-validator>
            <ig-feedback-group *ngIf="submitted">
                <ig-feedback *ngIf="errors('emailAddress').required"
                    i18n="@@email.errors.required">
                    E-mailadres is verplicht
                </ig-feedback>
                <ig-feedback *ngIf="errors('emailAddress').email"
                    i18n="@@email.errors.email">
                    Geen geldig e-mailadres
                </ig-feedback>
            </ig-feedback-group>
        </div>
    </fieldset>
    <fieldset>
        <p style="margin-bottom: 0; font-size: 12px;">
            <ng-container i18n="@@privacy1">Voor deze service werken wij samen met Pluimers Isolatie.
                Hiervoor geldt het volgend </ng-container>&#32;
            <a [href]="privacyStatementUrl"
                target="_blank">
                <ng-container i18n="@@privacy2">privacy statement</ng-container>
            </a>.
        </p>
    </fieldset>

    <ig-footer>
        <ig-button-primary (click)="onPrevButtonClick($event)"
            i18n="@@footerButtonPrevious">
            vorige stap
        </ig-button-primary>
        <span class="spacer"></span>
        <ig-button-secondary (click)="onNextButtonClick($event)"
            i18n="@@footerButtonRequest">
            aanvragen
        </ig-button-secondary>
    </ig-footer>

</form>
